import {
  ACTIVATEEMAIL_PROFIL_UPDATE,
  PROFIL_GET,
  PROFIL_UPDATE,
} from './reduxConstant';

export const profilGet = (profil) => {
  return {
    type: PROFIL_GET,
    payload: {
      profil,
    },
  };
};

export const profilUpdate = (profil) => {
  return {
    type: PROFIL_UPDATE,
    payload: {
      profil,
    },
  };
};

export const activateEmailProfilUpdate = (profil) => {
  return {
    type: ACTIVATEEMAIL_PROFIL_UPDATE,
    payload: {
      profil,
    },
  };
};
